<template>
  <section class="room-picker" id="choose-room">
    <h2>Choose your room</h2>
    <!-- <div class="filters">
      <button class="calendar">
        <img src="@/assets/hotel-detail/ic_calendar_white.svg" alt="">
      </button>
      <button class="room">
        <img src="@/assets/hotel-detail/ic_room_white.svg" alt="">
      </button>
    </div> -->
    <room-card
      v-for="(room, key, index) in hotel.realInventory"
      :key="`room-id-${'' + key}`"
      :room="room"
      :plan="index+1"
      :hotelName="hotel.name"
      :bookingURL="hotel.budgetHotel.metadata.bookingURL"
      :hotelImages="hotel.images">
    </room-card>
  </section>
</template>

<script>
import RoomCard from '@/components/hotel-detail-page/RoomCard'
export default {
  components: {
    RoomCard
  },
  props: {
    hotel: Object
  }

}
</script>

<style lang="scss" scoped>
.room-picker {
  margin: 0;
  padding-top: 60px;
  border-bottom: 1px solid #E9E9E9;

  h2 {
    font-size: 20px;
    margin: 0 20px 20px 20px;
    color: $primary-black;
  }

  .filters {
    margin: 0 20px 40px 20px;

    button {
      margin-right: 20px;
      background-color: $primary-black;
      border: none;
      border-radius: 5px;
      padding: 10px 10px 9px 10px;
      outline: none;
    }

  }
}

@media (min-width: 768px) {
  .room-picker {
    padding-bottom: 80px;

    h2 {
      font-size: 42px;
      margin-left: 0;
    }

    .filters {
      margin-left: 0;
    }
  }
}
</style>
